<template>
  <div
    class="app-pill"
    role="radiogroup"
    :aria-label="ariaLabel"
  >
    <label
      v-for="option in normalizedOptions"
      :key="option.id"
      v-tooltip="{ placement: 'top' }"
      class="app-pill-option"
      :class="{ 'app-pill-option--selected': isSelected(option.id) }"
      :data-original-title="optionTooltip(option.id)"
    >
      <input
        class="app-pill-option__input"
        type="radio"
        :name="groupName"
        :value="option.id"
        :checked="isSelected(option.id)"
        :disabled="disabled"
        @change="handleChange(option.id)"
      />
      <span class="app-pill-option__label">{{ option.text }}</span>
    </label>
  </div>
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

let pillInstance = 0;

// Supports both the legacy Vue 2 API (`:value` + `@input`) and Vue 3 `v-model` via VModelCompat —
// emitting only `input` left `v-model` consumers (e.g. the time-off policy accrual pills) stuck on
// the initial value.
export default {
  name: 'AppPill',
  mixins: [VModelCompat],
  props: {
    modelValue: {
      type: [String, Number],
      default: undefined,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    name: {
      type: String,
      default: null,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    pillInstance += 1;

    return {
      generatedName: `app-pill-${pillInstance}`,
    };
  },
  computed: {
    groupName() {
      return this.name || this.generatedName;
    },
    normalizedOptions() {
      return this.options.map((option) => {
        if (option && typeof option === 'object') {
          const id = option.id ?? option.value;
          const text = option.text ?? option.label ?? String(id ?? '');

          return { id, text };
        }

        return { id: option, text: String(option) };
      });
    },
  },
  methods: {
    isSelected(optionId) {
      return String(optionId) === String(this.modelCompatValue);
    },
    handleChange(optionId) {
      if (this.disabled) { return };

      this.emitModelCompatValue(optionId);
    },
    optionTooltip(optionId) {
      const tooltip = this.tooltips[optionId] ?? this.tooltips[String(optionId)];

      return tooltip || '';
    },
  },
};
</script>
